<template>
	<div class="room-left" v-show="!shouldShowEcharts">
		<img class="alarm-icon" v-if="detailPageData.subStatus == 1 && detailPageData.hasAlarm == true && detailPageData.status != 4"
			src="./../../../assets/img/warning-circle-fill@2x.png" alt="" />
		<span class="leave-bed-alarm" v-if="detailPageData.subStatus == 1 &&
			detailPageData.hasAlarm == true && detailPageData.status != 4
			">{{ detailPageData.statusName }} {{ duration ? duration : '' }}</span>
		<span class="leave-bed-noalarm" v-if="detailPageData.subStatus == 1 &&
			detailPageData.status != 4 &&
			detailPageData.hasAlarm == false
			">{{ detailPageData.statusName }} {{ duration ? duration : '' }}</span>
		<span class="off-line" v-if="detailPageData.status == 3">离线</span>
		<span class="close" v-if="detailPageData.status == 4">监测仪已关闭</span>
	</div>
</template>

<script>
export default {
	name: 'RoomLeftStatusPanel',
	props: {
		detailPageData: {
			type: Object,
			default: () => ({}),
		},
		duration: {
			type: String,
			default: '',
		},
		shouldShowEcharts: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.room-left {
	flex: 1;
	width: 880px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;

	.alarm-icon {
		margin-right: 10px;
	}

	.off-line {
		color: #ff4d4f;
		font-size: 36px;
	}

	.close {
		color: #262626;
		font-size: 36px;
	}

	.leave-bed-alarm {
		color: #ff4d4f;
		font-size: 36px;
	}

	.leave-bed-noalarm {
		color: #53c31b;
		font-size: 36px;
	}
}
</style>
